// 월 이동 — 데스크톱 '‹ 2026년 9월 ›', ≤768 은 월 pill + 선택 시트 (결정 14).
// props: { ym:'YYYY-MM', onChange(next), months }  months = 시트에 보여줄 개수(기본 12)
import React, { useState } from 'react';
import { T, R } from '../../theme';
import { useIsMobile } from '../../../utils/useMobile';
import { useLocale } from '../../../i18n/I18nProvider';
import { monthLabel, shiftMonth, currentMonth } from '../fmt';
import { SheetFrame } from './ConfirmSheet';

var wrap = { display: 'inline-flex', alignItems: 'center', gap: 6 };
var arrow = { width: 30, height: 30, borderRadius: R.md, border: '1px solid ' + T.bd, background: T.card,
  color: T.body, cursor: 'pointer', fontFamily: 'inherit', fontSize: 14, lineHeight: 1 };
var label = { fontSize: 13, fontWeight: 800, color: T.ink, minWidth: 96, textAlign: 'center' };
var pill = { display: 'inline-flex', alignItems: 'center', gap: 6, height: 30, padding: '0 12px', borderRadius: R.pill,
  border: '1px solid ' + T.bd, background: T.card, color: T.body, fontSize: 12.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' };
var item = { display: 'block', width: '100%', textAlign: 'start', padding: '11px 12px', borderRadius: R.md,
  fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' };

function MonthNav(props) {
  var isMobile = useIsMobile();
  var loc = useLocale();
  var st = useState(false);
  var open = st[0], setOpen = st[1];
  var ym = props.ym || currentMonth();
  var onChange = props.onChange || function () {};
  var text = monthLabel(loc.locale, ym);

  if (!isMobile) {
    return (<span className="ss-monthnav" style={wrap}>
      <button type="button" className="ss-flipx" style={arrow} aria-label={monthLabel(loc.locale, shiftMonth(ym, -1))}
        onClick={function () { onChange(shiftMonth(ym, -1)); }}>‹</button>
      <span style={label}>{text}</span>
      <button type="button" className="ss-flipx" style={arrow} aria-label={monthLabel(loc.locale, shiftMonth(ym, 1))}
        onClick={function () { onChange(shiftMonth(ym, 1)); }}>›</button>
    </span>);
  }

  var base = currentMonth();
  var list = [];
  for (var i = 0; i < (props.months || 12); i++) list.push(shiftMonth(base, -i));
  return (<span className="ss-monthnav">
    <button type="button" style={pill} onClick={function () { setOpen(true); }}>{text}</button>
    <SheetFrame open={open} title={text} onClose={function () { setOpen(false); }}>
      {list.map(function (m) {
        var on = m === ym;
        return (<button key={m} type="button"
          style={Object.assign({}, item, { background: on ? T.accentTint : T.card, color: on ? T.accentPress : T.body,
            border: '1px solid ' + (on ? T.accentBd : T.bd) })}
          onClick={function () { setOpen(false); onChange(m); }}>{monthLabel(loc.locale, m)}</button>);
      })}
    </SheetFrame>
  </span>);
}

export default MonthNav;
